import { App, Directive } from 'vue'

/* Registers every directive in this folder globally, named after its file */
const directiveModules = import.meta.glob<{ default: Directive }>(['./*.ts', '!./index.ts'], {
  eager: true,
})

export default function registerGlobalDirectives(app: App) {
  for (const [fileName, module] of Object.entries(directiveModules)) {
    const directiveName = fileName.replace(/^\.\/|\.\w+$/g, '')
    app.directive(directiveName, module.default)
  }
}
